import { FaArrowUp } from "react-icons/fa";
import React, { useEffect, useRef, useState } from "react";

const ProgressScroll = () => {
  const progressRef = useRef(null);
  const valueRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [hideOnFooter, setHideOnFooter] = useState(false);

  // Observe footer
  useEffect(() => {
    const footerElement = document.querySelector("footer"); // assumes <footer> is used
    if (!footerElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHideOnFooter(entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.1,
      },
    );

    observer.observe(footerElement);
    return () => {
      observer.unobserve(footerElement);
    };
  }, []);

  // Scroll percentage tracking
  useEffect(() => {
    const handleScroll = () => {
      const scrollProgress = progressRef.current;
      const pos = document.documentElement.scrollTop || document.body.scrollTop;
      const calcHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollValue = Math.round((pos * 100) / calcHeight);

      if (scrollProgress) {
        setVisible(pos > 100 && !hideOnFooter);
        scrollProgress.style.background = `conic-gradient(#203CA7 ${scrollValue}%, transparent ${scrollValue}%)`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("load", handleScroll);
    };
  }, [hideOnFooter]);

  const scrollToTop = () => {
    document.documentElement.scrollTop = 0;
  };

  return (
    <div
      ref={progressRef}
      onClick={scrollToTop}
      className={`fixed end-0 bottom-16 z-50 m-4 size-12 cursor-pointer place-items-center rounded-full shadow-2xl transition-all duration-500 ${
        visible ? "grid opacity-100" : "hidden opacity-0"
      }`}
    >
      <span
        ref={valueRef}
        className="text-dark grid size-9 place-items-center rounded-full bg-white text-lg transition-transform duration-300 hover:scale-110 hover:shadow-[0_0_10px_#203CA7]"
      >
        <FaArrowUp />
      </span>
    </div>
  );
};

export default ProgressScroll;
